/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GetCompanyBusinessPartnerIdRequest = {
  properties: {
    cnpj: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
